module.exports = __webpack_public_path__ + "static/media/2DGACM8.6bb07b9d.jpg";